import React from "react"
import { ReactComponent as TableBaseIcon } from "../../../assets/icons/table-base-icon.svg"
import { ReactComponent as CalcIcon } from "../../../assets/icons/calc-icon.svg"
import {
    ACCESS_PAGE,
    CLIENT_PAGE,
    DELETE_DATA_PAGE,
    IMPORT_PAGE,
    INTEGRATION_DATA_PAGE,
    PARAMETERS_CALC_PAGE,
    PARAMETERS_DATALAKE_PAGE,
    PRODUCT_PAGE,
    ROUTINES_HOME_PAGE,
    USER_PAGE,
} from "../../../../utils/routes"

export const CREDIT_CALC = [
    {
        icon: <TableBaseIcon />,
        name: "Parâmetros",
        id: "menu_calc_parametros",
        to: PARAMETERS_CALC_PAGE,
    },
    {
        icon: <CalcIcon />,
        name: "Tratamento Spreads",
        id: "menu_calc_tratamento",
        to: "",
    },
    {
        icon: <CalcIcon />,
        name: "Contigência",
        id: "menu_calc_contigencia",
        to: ROUTINES_HOME_PAGE,
    },
    {
        icon: <CalcIcon />,
        name: "Processos",
        id: "menu_calc_processos",
        to: "#",
    },
]

export const ACCESS = [
    {
        icon: <TableBaseIcon />,
        name: "Clientes",
        id: "menu_acesso_clientes",
        to: CLIENT_PAGE,
    },
    {
        icon: <TableBaseIcon />,
        name: "Usuários",
        id: "menu_acesso_usuarios",
        to: USER_PAGE,
    },
    {
        icon: <TableBaseIcon />,
        name: "Produtos",
        id: "menu_acesso_produtos",
        to: PRODUCT_PAGE,
    },
    {
        icon: <TableBaseIcon />,
        name: "Grupos",
        id: "menu_acesso_grupos",
        to: ACCESS_PAGE,
    },
    {
        icon: <TableBaseIcon />,
        name: "Trilha de auditoria",
        id: "menu_acesso_grupos",
        to: "#",
    },
]

export const DATALAKE = [
    {
        icon: <TableBaseIcon />,
        name: "Consulta de dados",
        id: "menu_data_lake_consulta_dados",
        to: PARAMETERS_DATALAKE_PAGE,
    },
    {
        icon: <CalcIcon />,
        name: "Integração Dados Externos",
        id: "menu_data_lake_market_data",
        to: INTEGRATION_DATA_PAGE,
    },
    {
        icon: <CalcIcon />,
        name: "Importação de Dados",
        id: "menu_data_lake_importacao_dados",
        to: IMPORT_PAGE,
    },
    {
        icon: <CalcIcon />,
        name: "Exclusão de Dados",
        id: "menu_data_lake_exclusao_dados",
        to: DELETE_DATA_PAGE,
    },
]
